import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/Warning.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "100",
  height: "100",
  alt: "Alerta"
}, null, -1)
const _hoisted_2 = { class: "popUpTDP" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Estamos verificando tu aceptación de la última versión del Tratamiento de Datos o los Términos y Condiciones. Intenta nuevamente en unos minutos.", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, " términos y condiciones. ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  style: {"color":"#f68b1e"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "*No es posible continuar hasta no haber leído y autorizado los términos y condiciones.")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 3,
  style: {"color":"#f68b1e"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Descargando...")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 4,
  style: {"color":"#f68b1e"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Actualmente, la descarga del archivo PDF está tomando más tiempo de lo habitual. Te sugerimos intentarlo nuevamente más tarde.")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 5,
  style: {"color":"#f68b1e"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Estamos actualizando tu aprobación de los términos y condiciones. Vuelve a intentarlo más tarde para completar el proceso.")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 6,
  style: {"color":"#f68b1e"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Procesando...")
], -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: "",
    closable: false,
    header: "Importante",
    draggable: false,
    id: "p-dialog"
  }, {
    footer: _withCtx(() => [
      (!$setup.sinSalidaDePlans)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "TDPBtn",
            onClick: $setup.redirigirTransmision,
            disabled: $setup.procesando,
            text: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("← Volver")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        class: "TDPBtn",
        onClick: $setup.Validarcheck,
        disabled: $setup.procesando,
        text: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.nombreBotonConfirmTYC), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 20,
            sm: 20,
            md: 20,
            lg: 20,
            xl: 20
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                ($props.StoreVacio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                  : _createCommentVNode("", true),
                (!$props.StoreVacio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString($props.textoPopUpTYC) + " ", 1),
                        _hoisted_7,
                        _hoisted_8,
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_checkbox, {
                            modelValue: $setup.checkTYC,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkTYC) = $event)),
                            disabled: $setup.procesando
                          }, null, 8, ["modelValue", "disabled"]),
                          _createTextVNode(" He leído y acepto los "),
                          _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.obtenerTYC()))
                          }, _hoisted_10)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.obligatorio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                  : _createCommentVNode("", true),
                ($setup.descargando)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                  : _createCommentVNode("", true),
                ($setup.errorPDF)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                  : _createCommentVNode("", true),
                ($setup.errorAPI)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                  : _createCommentVNode("", true),
                ($setup.procesando)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}